import { render, staticRenderFns } from "./ResultsCount.vue?vue&type=template&id=17910dc3"
import script from "./ResultsCount.vue?vue&type=script&lang=js"
export * from "./ResultsCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports